/**
 * Converts a number into a shorter format by dividing it by 1000 and appending 'K' to the end.
 *
 * @param num - The number to be shortened. Defaults to 0 if not provided.
 *
 * @returns The shortened number as a string, followed by 'K'.
 * If the number provided is 2500, the function returns '3K'.
 */
export const getShortNumber = (num = 0) => {
  const dividedNum = Math.round(Number(num) / 1000);
  return `${dividedNum}K`;
};
